import * as Yup from 'yup';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { useTranslation } from 'react-i18next';

export type PasswordForm = {
  currentPassword: string;
  updatePassword: string;
  updateConfirmPassword: string;
};
export const _passwordForm: PasswordForm = {
  currentPassword: '',
  updatePassword: '',
  updateConfirmPassword: '',
};

const usePasswordForm = (useCurrentPassword = true) => {
  const { t } = useTranslation();

  const BaseRule = Yup.string().matches(
    /^(?=.*[A-Za-z])(?=.*\d)(?=.*[^A-Za-z\d])[A-Za-z\d~!@#$%^&*()_+\-={}[\]|\\:;"'<>,.?/]{8,16}$/,
    '8-16자의 영문, 숫자, 특수문자 사용',
  );
  const getSchema = (useCurrentPassword = true) => {
    const currentPassword = Yup.string();
    if (useCurrentPassword) {
      currentPassword.required(t('현재 비밀번호를 입력해주세요.'));
    }

    const shapeObject = {
      currentPassword,
      updatePassword: BaseRule,
      updateConfirmPassword: BaseRule.oneOf(
        [Yup.ref('updatePassword')],
        '비밀번호가 일치하지 않습니다.',
      ).required(t('비밀번호가 일치하지 않습니다.')),
    };
    return Yup.object().shape(shapeObject);
  };
  return useForm<PasswordForm>({
    resolver: yupResolver(getSchema(useCurrentPassword)),
    defaultValues: _passwordForm,
    mode: 'onChange',
  });
};

export default usePasswordForm;
